<template>
  <div>
    <ul class="tabCom f26 l">
      <li v-for="(item,index) in tabData"
          :key="index"
          :class="{'active':activeIndex === index}"
          @click="$emit('changeTab', index)"
          v-show='show(index)'
          >{{item.name}}</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'tabCom',
    props: {
      tabData: {
        type: Array,
        default: () => []
      },
      activeIndex: {
        type: Number,
        default: () => 0
      },
      tabFlag : {
        type : Boolean,
        default : () => true
      }
    },
    data () {
      return {
      }
    },
    watch: {},
    computed: {},
    created () {
    },
    mounted () {
    },
    methods: {
      show(index){
        if(index == 2 && !this.tabFlag) return false
        return true
      }
    }
  }
</script>

<style lang="scss" scoped>
.tabCom{
  padding: 6px 8px;
  border: 1px $primary-color solid;
  height:44px;
  border-radius:28px;
  display: flex;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  li{
    height: 44px;
    line-height: 44px;
    padding: 0 30px;
    border-radius: 22px;
    transition: .2s;
  }
  .active{
    background: $primary-color;
    color: $white-color;
  }
}
</style>
